export const DDWA_PROPOSAL_INFO_FORM_ID = 'ddwa-proposal-info-form';
